import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../types.d.ts" />
import classnames from 'classnames';
import React from 'react';
import './lifeline.scss';
export const ActionToast = (props)=>{
    const { children, className, onAction, actionText, ...spreadable } = props;
    const backMessageStyles = classnames(props, `cmx-lifeline`, 'qa-ActionToast');
    const handleClick = (event)=>{
        onAction(window.location.pathname);
    };
    return /*#__PURE__*/ _jsxs("div", {
        ...spreadable,
        className: classnames(backMessageStyles),
        children: [
            props.message,
            ' ',
            /*#__PURE__*/ _jsx("span", {
                className: "c-hand qa-action-link ",
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx("b", {
                    children: actionText
                })
            })
        ]
    });
};
